module.exports = __webpack_public_path__ + "static/media/Iconfield03.bab1f3b4.svg";